import { AvatarWithInitials } from '@eluve/blocks';
import { Box, Tag, Text } from '@eluve/components';
import { formatHumanName } from '@eluve/utils';

import { UserOptionInfo } from './utils';

export const UserOption: React.FC<UserOptionInfo> = (user) => {
  const name = formatHumanName(user.firstName, user.lastName);

  return (
    <Box hStack className="gap-4 py-1">
      <AvatarWithInitials name={name} id={user.id} />
      <Box vStack className="w-full flex-1">
        <Text
          size="md"
          weight="semibold"
          color="primary"
          className="privacy-text"
        >
          {name}
        </Text>
        {user.email && <Tag color="gray" label={user.email} size="xs" />}
      </Box>
    </Box>
  );
};
